package com.devi3east.bashbuddy.ktor.stripe.data.api

import com.devi3east.bashbuddy.account.organization.domain.models.StripeAccount
import com.devi3east.bashbuddy.ktor.stripe.requests.CreateAccountLinkRequest
import com.devi3east.bashbuddy.ktor.stripe.requests.CreateConnectedAccountRequest
import com.devi3east.bashbuddy.ktor.stripe.responses.CreateAccountLinkResponse
import com.devi3east.bashbuddy.ktor.stripe.responses.CreateConnectedAccountResponse
import com.devi3east.bashbuddy.ktor.stripe.responses.DashboardLinkResponse
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpHeaders
import io.ktor.http.contentType

class StripeApi(
    private val client: HttpClient,
    private val baseUrl: String
) {

    suspend fun createConnectedAccount(token: String, email: String): CreateConnectedAccountResponse {
        val response = client.post("$baseUrl/stripe/create-connected-account") {
            headers.append(HttpHeaders.Authorization, "Bearer $token")
            contentType(ContentType.Application.Json)
            setBody(CreateConnectedAccountRequest(email))
        }.body<CreateConnectedAccountResponse>()
        return response
    }

    suspend fun createAccountOnboardingLink(token: String, accountId: String): CreateAccountLinkResponse {
        val response = client.post("$baseUrl/stripe/create-account-link") {
            headers.append(HttpHeaders.Authorization, "Bearer $token")
            contentType(ContentType.Application.Json)
            setBody(CreateAccountLinkRequest(accountId))
        }.body<CreateAccountLinkResponse>()
        return response
    }

    suspend fun getDashboardLink(token: String): DashboardLinkResponse {
        return client.post("$baseUrl/stripe/dashboard-link") {
            headers.append(HttpHeaders.Authorization, "Bearer $token")
        }.body()
    }

    suspend fun getStripeAccount(
        token: String
    ): StripeAccount {
        return client.get("$baseUrl/stripe/account") {
            headers.append(HttpHeaders.Authorization, "Bearer $token")
        }.body()
    }

}